export default function getResource(label, vars = []) {
    const resources = {
        freeReturns: 'Free returns on all purchases*',
        infoIcon: 'Free Returns info',
        applyNow: 'Apply Now ▸',
        offerForYou: '<b>Offer for You: </b>Use code ',
        offerForYouCode: `<b>${vars[0]}</b> to get ${vars[1]}% off any ${vars[2]}.`,
        promoInfoModalTitle: 'Offer for You Disclaimer / Info'
    };

    return resources[label];
}
